"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// aligned with ../../jsx.d.ts events
exports.lowerCaseEvents = [
    'abort',
    'animationend',
    'animationiteration',
    'animationstart',
    'blur',
    'cancel',
    'canplay',
    'canplaythrough',
    'change',
    'click',
    'compositionend',
    'compositionstart',
    'compositionupdate',
    'contextmenu',
    'copy',
    'cut',
    'cuechange',
    'doubleclick',
    'drag',
    'dragend',
    'dragenter',
    'dragexit',
    'dragleave',
    'dragover',
    'dragstart',
    'drop',
    'durationchange',
    'emptied',
    'encrypted',
    'ended',
    'error',
    'focus',
    'input',
    'invalid',
    'keydown',
    'keypress',
    'keyup',
    'load',
    'loadeddata',
    'loadedmetadata',
    'loadstart',
    'mousedown',
    'mouseenter',
    'mouseleave',
    'mousemove',
    'mouseout',
    'mouseover',
    'mouseup',
    'paste',
    'pause',
    'play',
    'playing',
    'progress',
    'ratechange',
    'reset',
    'scroll',
    'seeked',
    'seeking',
    'select',
    'stalled',
    'submit',
    'suspend',
    'timeupdate',
    'toggle',
    'touchcancel',
    'touchend',
    'touchmove',
    'touchstart',
    'transitionend',
    'volumechange',
    'waiting',
    'wheel'
];
/**
 * Turn attribute name to event name and capture flag
 * onClick -> click, false
 * onClickCapture -> click, true
 * onMouseMove -> mousemove, false
 * onMyEvent -> myEvent, false
 */
function normalizeEventName(attrName) {
    var name = attrName.substr(2); // remove on
    var capture = false;
    if (name.slice(-7) === 'Capture') { // remove Capture
        capture = true;
        name = name.slice(0, -7);
    }
    var lcAttrName = name.toLowerCase();
    name = exports.lowerCaseEvents.indexOf(lcAttrName) !== -1
        ? lcAttrName
        : lcAttrName[0] + name.substr(1); // turn first letter to lowercase
    return { name: name, capture: capture };
}
exports.normalizeEventName = normalizeEventName;
